module.exports={render:function (){with(this) {
  return _h('div', [_l((contents), function(content) {
    return _h('div', {}, [_h('topic', {
      attrs: {
        "content": content,
        "run": run
      }
    }), " ", _m(0, true)])
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('hr')
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac96f080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 260
// module chunks = 2